"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ItemProductBrand;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ChipStatus = require("../ChipStatus");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    container: {
      display: "flex"
    },
    left: {
      flex: "50%"
    },
    right: {
      flex: "50%",
      textAlign: "right"
    }
  };
});

function ItemProductBrand(_ref) {
  var brandName = _ref.brandName,
      id = _ref.id,
      status = _ref.status,
      props = _ref.props;
  var classes = useStyle();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.left
  }, /*#__PURE__*/_react["default"].createElement("span", null, brandName, " "), /*#__PURE__*/_react["default"].createElement("sup", null, "[", id, "]")), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.right
  }, /*#__PURE__*/_react["default"].createElement(_ChipStatus.ChipStatus, {
    code: status
  })));
}

ItemProductBrand.propTypes = {
  brandName: _propTypes["default"].string,
  id: _propTypes["default"].number,
  status: _propTypes["default"].oneOf([65, 64, 0, -1, -3, -126, -127])
};